import { Divider, Drawer, Input, Space, Slider, Spin, Form, Button, Alert, Checkbox, Segmented } from "antd";
import React, { useState } from "react";
import EditorPanelHeading from "../../UI/EditorPanelHeading";
import PresetPicker from "../../../globals/styles/PresetPicker";
import BMInput from "../../comps/BMInput";
import { PicRightOutlined, PicLeftOutlined, PicCenterOutlined } from '@ant-design/icons';
import { getColor } from "../../../utils/ConvertCSS";
import { useTemplate } from "../../../utils/Template";
import ColourPicker from "../../../globals/styles/ColourPicker";
import MailchimpSubscribe from "react-mailchimp-subscribe";
import ButtonPicker from "../../../globals/styles/ButtonPicker";
import { PaddingHorizontalIcon, PaddingVerticalIcon } from "../../Icons";
import { tt_name_block_warning } from "../../../utils/Utils";

export default function MailChimpEmbedded(props) {

    const { edit = false, close = () => { }, saveItem = () => { }, deleteItem = () => { }, id = 0 } = props;
    const [content, setContent] = useState(props.content);
    const [template,] = useTemplate();

    const setData = (_data) => {
        setContent({ ...content, "data": _data })
    }

    // Component agnostic
    const {
        name = "",
        container = true,
        data = {},
        date_changed = 0
    } = content;

    // Component specific
    const {
        url = "",
        heading = "Subscribe",
        heading_preset = 0,
        subheading = "",
        subheading_preset = 0,
        response_preset = 0,
        button_type = 0,
        show_name = false,
        show_phone = false,
        background_colour = 0,
        width = 1248,
        has_width = false,
        align = "0 auto",
        vertical = false,
        padding_x = 10,
        padding_y = 10,
    } = data;

    const save = () => {
        if (!name) {
            let _name = prompt(tt_name_block_warning);
            if (_name) {
                close();
                saveItem(id, { ...content, "name": _name });
            } else {
                return;
            }
        } else {
            close();
            saveItem(id, { ...content })
        }
    }

    const trash = () => {
        deleteItem(id);
        close();
    }

    const drawRender = () => {

        let _style = {
            padding: padding_y + "px " + padding_x + "px",
            maxWidth: (has_width) ? width + "px" : "100%",
            margin: align,
            textAlign: "center",
            background: getColor(background_colour, template)
        }

        return (
            <div id={"bm-" + id} className={(container) ? "preview-container" : ""}>
                <div>
                    <MailchimpSubscribe
                        url={url}
                        render={({ subscribe, status, message }) => (
                            <>
                                <Spin spinning={(status === "sending")}>
                                    <div style={_style} >
                                        {(heading &&
                                            <h3 className={"bm-txt-" + heading_preset}>{heading}</h3>
                                        )}
                                        {(subheading &&
                                            <p className={"bm-txt-" + subheading_preset}>{subheading}</p>
                                        )}
                                        <Form onFinish={(_f) => {
                                            if (_f.email) { subscribe(_f); }
                                        }} size={"large"} layout="vertical">
                                            <Space align="center" style={{ "justifyContent": "center" }} wrap direction={(vertical) ? "vertical" : "horizontal"}>
                                                <Form.Item style={{ "marginBottom": "0px" }} name="EMAIL">
                                                    <Input style={{ "width": "100%" }} placeholder="Email address..." type="email" />
                                                </Form.Item>
                                                {((show_name) && <>
                                                    <Form.Item style={{ "marginBottom": "0px" }} name="FNAME">
                                                        <Input placeholder="First name..." />
                                                    </Form.Item>

                                                    <Form.Item style={{ "marginBottom": "0px" }} name="LNAME">
                                                        <Input placeholder="Last name..." />
                                                    </Form.Item>
                                                </>)}
                                                {((show_phone) && <>
                                                    <Form.Item style={{ "marginBottom": "0px" }} name="PHONE">
                                                        <Input placeholder="Phone..." />
                                                    </Form.Item>
                                                </>)}
                                                <Form.Item style={{ "marginBottom": "0px" }} label={null}>
                                                    <Button className={"bm-btn-" + button_type} htmlType="submit" type="primary">Subscribe</Button>
                                                </Form.Item>
                                            </Space>
                                            <div className="shim" /><div className="shim" />
                                            {((status === "error" || status === "success") &&
                                                <div className={"bm-txt-" + response_preset}>{message}</div>
                                            )}
                                            <div className="shim" /><div className="shim" />
                                        </Form>
                                    </div>
                                </Spin>
                            </>
                        )}
                    />
                </div>
            </div>
        )
    }

    const drawForm = () => {
        return (
            <>
                <EditorPanelHeading menus={props.menus} close={close} trash={trash} save={save} content={content} setContent={setContent} date_changed={date_changed} name={name} />
                <Alert style={{ "lineHeight": "14px" }} type="info" message={<small>Paste the URL found within the "action" attribute from your embedded form code.
                    &nbsp; <a href="https://support.bookmanager.com/tutorials/webstore-designer/faq/mailchimp-signup" target="blank">View Support site for details</a>
                </small>} />
                <div className="shim" /> <div className="shim" />
                {/* MAILCHIMP SUBSCRIPTION URL */}

                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">MAILCHIMP SUBSCRIPTION URL</Divider>
                <Input style={{ "fontSize": "11px" }} onChange={(e) => setData({ ...data, "url": e.target.value })} value={url} placeholder="Subscription URL..." />
                <div className="shim" /> <div className="shim" />
                {/* HEADING */}
                <div className="group-wrap">
                    {/* HEADING PRESET */}
                    <Divider orientationMargin={0} orientation="left" plain className="simple-divider">HEADLINE PRESET</Divider>
                    <PresetPicker value={heading_preset} onChange={(e) => setData({ ...data, "heading_preset": e })} />
                    <div className="shim" /> <div className="shim" />
                    <Divider orientationMargin={0} orientation="left" plain className="simple-divider">HEADLINE</Divider>
                    <Input style={{ "fontSize": "11px" }} onChange={(e) => setData({ ...data, "heading": e.target.value })} value={heading} placeholder="Headline text..." />
                </div>
                <div className="shim" /> <div className="shim" />
                {/* SUBHEADING */}
                <div className="group-wrap">
                    {/* SUBHEADING PRESET */}
                    <Divider orientationMargin={0} orientation="left" plain className="simple-divider">SUBHEADING PRESET</Divider>
                    <PresetPicker value={subheading_preset} onChange={(e) => setData({ ...data, "subheading_preset": e })} />
                    <div className="shim" /> <div className="shim" />
                    <Divider orientationMargin={0} orientation="left" plain className="simple-divider">SUBHEADING</Divider>
                    <Input.TextArea style={{ "fontSize": "11px" }} value={subheading} onChange={(e) => setData({ ...data, "subheading": e.target.value })} rows={5} />
                </div>
                <div className="shim" /> <div className="shim" />
                {/* RESPONSE PRESET */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">RESPONSE PRESET</Divider>
                <PresetPicker value={response_preset} onChange={(e) => setData({ ...data, "response_preset": e })} />
                <div className="shim" /> <div className="shim" />
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">DISPLAY FIELDS</Divider>
                <Space>
                    <Checkbox onChange={(e) => setData({ ...data, "show_name": e.target.checked })} checked={show_name}><small>Name?</small></Checkbox>
                    <Checkbox onChange={(e) => setData({ ...data, "show_phone": e.target.checked })} checked={show_phone}><small>Phone?</small></Checkbox>
                </Space>
                <div className="shim" /> <div className="shim" />
                {/* ALIGN */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">STACK FORM ELEMENTS</Divider>
                <Segmented size="small" value={vertical} onChange={(e) => setData({ ...data, "vertical": e })} options={[{ label: <small>Vertical</small>, value: true }, { label: <small>Horizontal</small>, value: false }]} />
                <div className="shim" /> <div className="shim" />
                {/* ALIGN */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">ALIGN / PADDING</Divider>
                <div className="float-flex">
                    <Space>
                        <div><PicLeftOutlined onClick={() => setData({ ...data, "align": "0" })} style={{ "color": (align === "0") ? "#1890ff" : "#AAA" }} /></div>
                        <div><PicCenterOutlined onClick={() => setData({ ...data, "align": "0 auto" })} style={{ "color": (align === "0 auto") ? "#1890ff" : "#AAA" }} /></div>
                        <div><PicRightOutlined onClick={() => setData({ ...data, "align": "0 0 0 auto" })} style={{ "color": (align === "0 0 0 auto") ? "#1890ff" : "#AAA" }} /></div>
                    </Space>
                    <Space>
                        <BMInput value={padding_x} onChange={(_v) => setData({ ...data, "padding_x": _v })} number min={0} max={100} prefix={<PaddingHorizontalIcon style={{ "color": "#888" }} />} />
                        <BMInput value={padding_y} onChange={(_v) => setData({ ...data, "padding_y": _v })} number min={0} max={100} prefix={<PaddingVerticalIcon style={{ "color": "#888" }} />} />
                    </Space>
                </div>
                <div className="shim" /> <div className="shim" />
                {/* BACKGROUND COLOUR */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">BACKGROUND COLOUR</Divider>
                <ColourPicker allow_gradient allow_none value={background_colour} onChange={(_v) => setData({ ...data, "background_colour": _v })} />
                <div className="shim" /> <div className="shim" />
                {/* BUTTON TYPE */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">BUTTON TYPE</Divider>
                <ButtonPicker value={button_type} onChange={(e) => setData({ ...data, "button_type": e })} />
                <div className="shim" /> <div className="shim" />
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">MAX WIDTH</Divider>
                <div className="float-flex">
                    <Slider
                        style={{ "width": "130px" }}
                        min={0}
                        disabled={!has_width}
                        max={1248}
                        onChange={(_v) => setData({ ...data, "width": _v })}
                        value={width}
                    />
                    <Checkbox onChange={(e) => setData({ ...data, "has_width": e.target.checked })} checked={has_width}><small>Constrain?</small></Checkbox>
                </div>
            </>
        )
    }

    return (
        <>
            <Drawer bodyStyle={{ "backgroundColor": "#f5f5f5", "overflowX": "hidden" }} closable={false} width={300} onClose={() => close(true)} open={edit}>
                {drawForm()}
            </Drawer>
            {drawRender()}
        </>
    )

}